<template>
  <div v-if="optionalAddOn" class="results-add-on-toggle flex items-center justify-between py-200">
    <div>
      <LotteryAddOnLogo
        v-bind="{ licensedTerritory, lotteryId }"
        class="logo"
        :name="optionalAddOn.name"
        variant="text"
      />
      <p>
        {{
          $t('results.addontoggle.showwithaddon', {
            addOn: $t(`lottery.addon.${optionalAddOn.name}`),
          })
        }}
      </p>
    </div>

    <LcForm :tracking="{ containerId: 'results_add_on_form' }">
      <LcFormField v-slot="{ field }" name="showWithAddOn">
        <LcSwitch
          v-bind="field"
          v-model:value="showWithAddOn"
          :aria-label-text="
            $t('results.addontoggle.showwithaddon', {
              addOn: $t(`lottery.addon.${optionalAddOn.name}`),
            })
          "
        />
      </LcFormField>
    </LcForm>
  </div>
</template>

<script lang="ts" setup>
const { licensedTerritory, lotteryId, optionalAddOn, showWithAddOn } = await useResultDetails()
</script>

<style lang="scss" scoped>
.results-add-on-toggle {
  .logo {
    height: unset;
    font-size: 1rem !important;
  }
}
</style>
